// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const RemoteCursorFilledSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_5602)"},"children":[{"tag":"path","attrs":{"d":"M3 3l18 7.53v.98l-6.84 2.65L11.52 21h-.98L3 3z","fill":"currentColor","stroke":"#fff"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_5602"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"remote_cursor","theme":"filled"};

const RemoteCursorFilled = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={RemoteCursorFilledSvg} />;
  RemoteCursorFilled.displayName = 'RemoteCursorFilled';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(RemoteCursorFilled);
